"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_moment_1 = __importDefault(require("react-moment"));
require("moment/locale/de");
require("moment/locale/en-gb");
exports.default = react_1.forwardRef(function DateHelper(_a, ref) {
    var element = _a.component, format = _a.format, withTitle = _a.withTitle, _b = _a.titleFormat, titleFormat = _b === void 0 ? 'DD. MMMM  YYYY HH:mm' : _b, locale = _a.locale, rest = __rest(_a, ["component", "format", "withTitle", "titleFormat", "locale"]);
    var fromNow = rest.fromNow, toNow = rest.toNow, from = rest.from, to = rest.to, diff = rest.diff;
    var isRelative = Boolean(fromNow || toNow || from || to);
    if (isRelative === false && format === undefined && diff === undefined) {
        format = 'DD.MM.YYYY';
    }
    if (isRelative && withTitle === undefined) {
        withTitle = true;
    }
    if (locale === undefined && /de/i.test(window.navigator.language)) {
        locale = 'de';
    }
    return (jsx_runtime_1.jsx(react_moment_1.default, __assign({ ref: ref, withTitle: withTitle, titleFormat: titleFormat, locale: locale, format: format }, rest, { element: element }), void 0));
});
//# sourceMappingURL=DateHelper.js.map